export default "__VITE_ASSET__DU37u6JO__"